import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  familyInfo: Yup.object().shape({
    addressInfo: Yup.object().shape({
      villageId: Yup.string().required("Village is required"),
      villageOther: Yup.string().when("villageId", {
        is: (val) => Number(val) === 129000421,
        then: (schema) => schema.required("Other Village is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
    })
  }),
  individualInfo: Yup.object().shape({
    name: Yup.string()
      .trim()
      .required("Name is required"),

    surname: Yup.string()
      .nullable()
      .matches(/^[A-Za-z]+$/, {
        message: "Surname should contain only alphabets",
        excludeEmptyString: true
      }),

    gender: Yup.string().required("Gender is required"),

    birthDate: Yup.string().required("Date of birth is required"),

    age: Yup.number()
      .typeError("Valid age is required")
      .required("Age is required")
      .min(0, "Age must be positive")
      .max(150, "Age must be less than 150"),

    mobileNumber: Yup.string()
      .required("Mobile number is required")
      .matches(/^\d{10}$/, "Mobile number must be 10 digits"),

    // healthInsurance: Yup.boolean()
    //   .nullable()
    //   .required("Please select Health Insurance status"),

    healthInsuranceDetails: Yup.string().when("healthInsurance", {
      is: true,
      then: (schema) => schema.required("Details of scheme are required"),
      otherwise: (schema) => schema.notRequired(),
    }),

    pvtgIndividual: Yup.boolean()
      .nullable()
      .required("PVTG Status is required"),

    individualIds: Yup.object().shape({
      VoterID: Yup.object().shape({
        idValue: Yup.string()
          .nullable()
          .matches(/^\d{10}$/, {
            message: "Voter ID must be 10 digits",
            excludeEmptyString: true
          })
      }),

      Pan: Yup.object().shape({
        idValue: Yup.string()
          .nullable()
          .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, {
            message: "PAN must be in format: ABCDE1234F",
            excludeEmptyString: true
          })
      }),

      DrivingLicense: Yup.object().shape({
        idValue: Yup.string()
          .nullable()
          .matches(/^[A-Z0-9]{16}$/, {
            message: "Driving License must be 16 alphanumeric characters",
            excludeEmptyString: true
          })
      }),

      SECC: Yup.object().shape({
        idValue: Yup.string()
          .nullable()
          .matches(/^\d{10}$/, {
            message: "SECC must be 10 digits",
            excludeEmptyString: true
          })
      }),

      NPR: Yup.object().shape({
        idValue: Yup.string()
          .nullable()
          .matches(/^\d{8,10}$/, {
            message: "NPR/BP Passport must be 8-10 digits",
            excludeEmptyString: true
          })
      }),

      uhcId: Yup.object().shape({
        idValue: Yup.string()
          .nullable()
          .matches(/^\d{12}$/, {
            message: "UHC ID must be 12 digits",
            excludeEmptyString: true
          })
      }),
    }),
  }),

});